import { useCallback } from 'react'
import { useMutation } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { APIError } from '../../../utils'
import { updateScoutConnection, UpdateScoutConnectionPayload } from '../query-api'

interface UseUpdateScoutConnectionArgs {
  onError?: (error: APIError) => void
  onSuccess?: () => void
}

export const useUpdateScoutConnection = ({ onError, onSuccess }: UseUpdateScoutConnectionArgs = {}) => {
  const { organization } = useUserOrganization()
  const { isLoading: isProcessing, mutate: update } = useMutation(
    (data: UpdateScoutConnectionPayload) => updateScoutConnection(data),
    {
      onError: (error: APIError) => {
        onError?.(error)
      },
      onSuccess: () => {
        onSuccess?.()
      },
    },
  )

  const updateConnection = useCallback(
    (updatePayload: Omit<UpdateScoutConnectionPayload, 'organizationId'>) => {
      return organization && update({ ...updatePayload, organizationId: organization.id })
    },
    [update, organization],
  )

  return {
    update: updateConnection,
    isProcessing,
  }
}
